export const styles = theme => ({
  span: {
    textAlign: 'left',
  },
  label: {

    display: 'inline-block',
    fontFamily: 'AvenirNext-Medium',
    fontSize: '18px',
    fontWeight: '500',
    color: '#3b3b3b',
    margin: '0 10px'
  },
  control: {
    margin: '0 3px 5px'
  },
  select: {
    backgroundColor: 'transparent',
    padding: theme.spacing(0, 1),
    '& > .MuiSelect-icon': {
      color: '#887fff',
    },
    '&:before': {
      borderBottomColor: '#887fff',
    }
  },
  selectInput: {
    padding: 3,
    minHeight: 0,
    fontFamily: 'AvenirNext-Bold',
    fontSize: '18px',
    color: '#887fff',
  }
})